import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import i18n from "./i18n";

import {BrowserRouter} from "react-router-dom";
import { msalInstance } from "./security/AuthProvider";

ReactDOM.render((

    <BrowserRouter>
        <App pca={msalInstance} />
    </BrowserRouter>
), document.getElementById('root'));
